<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">For my husband, Alain Lentz, who loves me unconditionally, you are my one and only and everything.</p><br/>
<p style="text-align: center;">For my beloved family and friends who nurture me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?54075584